import { useState, useEffect } from 'react';
import { getAnnonces } from 'src/service/annonceApi';
import { useNotification } from 'src/contexts/NotificationContext';

export const useFoundCount = () => {
  const [foundCount, setFoundCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const { refreshTrigger } = useNotification();

  const fetchFoundCount = async () => {
    try {
      const annonces = await getAnnonces('?status=TROUVÉ');
      setFoundCount(annonces.length || 0);
    } catch (error) {
      console.error('Erreur lors de la récupération du nombre d\'objets trouvés:', error);
      setFoundCount(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFoundCount();
    
    // Rafraîchir toutes les 30 secondes
    const interval = setInterval(fetchFoundCount, 30000);
    
    return () => clearInterval(interval);
  }, [refreshTrigger]); // Ajouter refreshTrigger comme dépendance

  return { foundCount, loading, refetch: fetchFoundCount };
}; 